(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9412],{

/***/ 95821:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mail",
      function () {
        return __webpack_require__(15556);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 69224:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ shared_Layout; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs
var _inherits = __webpack_require__(28668);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 1 modules
var _create_super = __webpack_require__(71418);
// EXTERNAL MODULE: ./node_modules/aos/dist/aos.js
var aos = __webpack_require__(2711);
// EXTERNAL MODULE: ./node_modules/@opendoor/shared-fe/build/faviconPath.js
var faviconPath = __webpack_require__(71390);
// EXTERNAL MODULE: ./src/components/globals.ts
var globals = __webpack_require__(35480);
;// CONCATENATED MODULE: ./src/components/WordpressPorts.tsx










var NextHead = (head_default());
var metaDescription = "Opendoor is the new way to sell your home. " + "Skip the hassle of listing, showings and months of stress, and " + "close on your own timeline. Get a free offer today!";
var Head = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NextHead, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
                children: "Opendoor | Sell your home the minute you’re ready."
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                name: "description",
                content: metaDescription
            }, "description"),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                charSet: "utf-8"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                httpEquiv: "X-UA-Compatible",
                content: "IE=edge,chrome=1"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                name: "viewport",
                content: "width=device-width,initial-scale=1"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                httpEquiv: "Accept-CH",
                content: "DPR, Width, Viewport-Width"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                rel: "shortcut icon",
                href: (0,faviconPath/* default */.Z)({
                    railsEnv: globals/* DEPLOY_ENV */.Zp
                }),
                type: "image/png"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                rel: "apple-touch-icon",
                sizes: "144x144",
                href: "https://www.opendoor.com/apple-touch-icon-144.png"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                rel: "preload",
                crossOrigin: "anonymous",
                href: "/fonts/graphik-regular/Graphik-Regular.woff",
                as: "font"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                rel: "preload",
                crossOrigin: "anonymous",
                href: "/fonts/graphik-medium/Graphik-Medium.woff",
                as: "font"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                rel: "preload",
                crossOrigin: "anonymous",
                href: "/fonts/graphik-semibold/Graphik-Semibold.woff",
                as: "font"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                rel: "preload",
                crossOrigin: "anonymous",
                href: "/fonts/graphik-bold/Graphik-Bold.woff",
                as: "font"
            })
        ]
    });
};
var Page = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(Page, _Component);
    var _super = (0,_create_super/* default */.Z)(Page);
    function Page() {
        (0,_class_call_check/* default */.Z)(this, Page);
        return _super.apply(this, arguments);
    }
    var _proto = Page.prototype;
    _proto.componentDidMount = function componentDidMount() {
        window.requestAnimationFrame(function() {
            aos.init();
        });
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;-webkit-flex-direction:column;flex-direction:column;-webkit-box-flex:1;-ms-flex:1;-webkit-flex:1;flex:1;margin:0 auto;background-color:#fff;position:relative;"),
            children: this.props.children
        });
    };
    return Page;
}(react.Component);

// EXTERNAL MODULE: ./src/components/shared/GlobalStyles.tsx
var GlobalStyles = __webpack_require__(54991);
// EXTERNAL MODULE: ./src/components/shared/Header.tsx
var Header = __webpack_require__(92013);
// EXTERNAL MODULE: ./src/components/shared/MenuPanel.tsx
var MenuPanel = __webpack_require__(37197);
;// CONCATENATED MODULE: ./src/components/shared/Layout.tsx








var assetPrefix = "https://cdn.opendoor.com/fonts";
var GlobalCss = "\n@font-face {\n  font-family: 'Publico, serif';\n  src: url('".concat(assetPrefix, "/PublicoHeadline-Bold-Web.eot?#iefix')\n      format('embedded-opentype'),\n    url('").concat(assetPrefix, "/PublicoHeadline-Bold-Web.woff') format('woff'),\n    url('").concat(assetPrefix, "/PublicoHeadline-Bold-Web.ttf') format('truetype'),\n    url('").concat(assetPrefix, "/PublicoHeadline-Bold-Web.svg#PublicoHeadline-Bold-Web') format('svg');\n  font-weight: 600;\n  font-style: bolder;\n}\n");
var Layout = function(props) {
    var ref = (0,react.useState)(false), isMenuOpen = ref[0], setMenuOpen = ref[1];
    var toggleMenuOpen = function() {
        return setMenuOpen(!isMenuOpen);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            Head(),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
                        children: "Opendoor"
                    }, "title"),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "preload",
                        crossOrigin: "anonymous",
                        href: "/fonts/PublicoHeadline-Bold-Web.woff2",
                        as: "font"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("style", {
                        dangerouslySetInnerHTML: {
                            __html: GlobalCss
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Page, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GlobalStyles/* default */.Z, {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("min-height:100vh;margin:0 auto;"),
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuPanel/* default */.ZP, {
                                active: isMenuOpen,
                                toggleMenuOpen: toggleMenuOpen
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuPanel/* MenuOverlay */.TJ, {
                                onClick: toggleMenuOpen,
                                active: isMenuOpen
                            }),
                            !props.hideHeader && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header/* default */.Z, {
                                isMenuOpen: isMenuOpen,
                                toggleMenuOpen: toggleMenuOpen,
                                hideHeaderNavLinks: props.hideHeaderNavLinks
                            }),
                            props.children
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var shared_Layout = (Layout);


/***/ }),

/***/ 15556:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ mail; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs
var _inherits = __webpack_require__(28668);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 1 modules
var _create_super = __webpack_require__(71418);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Flex/Flex.mjs
var Flex = __webpack_require__(93298);
// EXTERNAL MODULE: ./node_modules/@opendoor/cinderblocks/es/helpers/api.mjs
var api = __webpack_require__(82293);
// EXTERNAL MODULE: ./node_modules/@opendoor/observability/dist/observability-slim.mjs
var observability_slim = __webpack_require__(74593);
// EXTERNAL MODULE: ./src/components/api/index.ts + 2 modules
var components_api = __webpack_require__(67945);
// EXTERNAL MODULE: ./src/components/globals.ts
var globals = __webpack_require__(35480);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(46523);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/index.js
var Text = __webpack_require__(76614);
// EXTERNAL MODULE: ./src/components/shared/NewAddressInput.tsx
var NewAddressInput = __webpack_require__(98066);
;// CONCATENATED MODULE: ./src/components/mail/AddressEntryPage.tsx







var AddressEntryPage = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(AddressEntryPage, _PureComponent);
    var _super = (0,_create_super/* default */.Z)(AddressEntryPage);
    function AddressEntryPage() {
        (0,_class_call_check/* default */.Z)(this, AddressEntryPage);
        return _super.apply(this, arguments);
    }
    var _proto = AddressEntryPage.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
            gap: "$10x",
            padding: "$10x",
            $smallerThanMD: {
                width: "100%"
            },
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                    tag: "h1",
                    textAlign: "center",
                    $largerThanSM: {
                        textAlign: "left",
                        typography: "$subheaderXsmall"
                    },
                    typography: "$subheaderSmall",
                    children: "Unsubscribe from mail"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                    tag: "h3",
                    textAlign: "center",
                    $largerThanSM: {
                        textAlign: "left",
                        typography: "$bodyMedium"
                    },
                    typography: "$bodySmall",
                    children: "Please enter the address where you would no longer like to receive mail from Opendoor."
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewAddressInput/* default */.Z, {
                    onChooseManualEntry: this.props.onChooseManualEntry,
                    onSubmit: this.props.onSubmit,
                    showCta: true,
                    // @ts-expect-error: Type mismatch caused by withRouter's inability to infer the correct variant of IProps (either AddressInputProps or AddressInputWithCtaProps).
                    // We know that ctaProps will be conditionally passed
                    ctaProps: {
                        actionText: "Unsubscribe",
                        "aria-label": ""
                    }
                })
            ]
        });
    };
    return AddressEntryPage;
}(react.PureComponent);

// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Box/Box.mjs
var Box_Box = __webpack_require__(8013);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Heading/Heading.mjs
var Heading = __webpack_require__(37982);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Text/Text.mjs
var Text_Text = __webpack_require__(4796);
;// CONCATENATED MODULE: ./src/components/mail/ErrorPage.tsx






var ErrorPage = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ErrorPage, _PureComponent);
    var _super = (0,_create_super/* default */.Z)(ErrorPage);
    function ErrorPage() {
        (0,_class_call_check/* default */.Z)(this, ErrorPage);
        return _super.apply(this, arguments);
    }
    var _proto = ErrorPage.prototype;
    _proto.render = function render() {
        var casaAddress = this.props.casaAddress;
        var unit = casaAddress && casaAddress.unitNumber && casaAddress.unitNumber ? casaAddress.unitType + " " + casaAddress.unitNumber : null;
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box_Box/* default */.Z, {
            maxWidth: "600px",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading.H3, {
                    width: "100%",
                    textAlign: [
                        "center",
                        null,
                        "left"
                    ],
                    mb: 7,
                    children: "Something went wrong"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text_Text/* default */.Z, {
                    textAlign: [
                        "center",
                        null,
                        "left"
                    ],
                    mb: 7,
                    children: [
                        "There was a problem unsubscribing ",
                        casaAddress ? casaAddress.street : "your home",
                        unit && ", ".concat(unit),
                        " from our mailing list. Please email your full address to mail@opendoor.com to unsubscribe."
                    ]
                })
            ]
        });
    };
    return ErrorPage;
}(react.PureComponent);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Button/Button.mjs
var Button = __webpack_require__(26029);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Input/Input.mjs + 2 modules
var Input = __webpack_require__(16937);
;// CONCATENATED MODULE: ./src/components/mail/ManualAddressPage.tsx










var ManualAddressPage = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ManualAddressPage, _PureComponent);
    var _super = (0,_create_super/* default */.Z)(ManualAddressPage);
    function ManualAddressPage() {
        (0,_class_call_check/* default */.Z)(this, ManualAddressPage);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            address: _this.props.addressInput || {},
            loadingSubmit: false
        };
        _this.handleOnChange = function(name, value) {
            var address = _this.state.address;
            _this.setState({
                address: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, address), (0,_define_property/* default */.Z)({}, name, value))
            });
        };
        _this.handleModifyAddress = function() {
            _this.setState({
                loadingSubmit: true
            });
            _this.props.modifyAddress(_this.state.address);
        };
        _this.handleCancel = function() {
            _this.props.cancelManualAddressVerification(!!_this.props.addressInput);
        };
        return _this;
    }
    var _proto = ManualAddressPage.prototype;
    _proto.render = function render() {
        var _this = this;
        var address = this.state.address;
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box_Box/* default */.Z, {
            flex: [
                "1 0 auto",
                null,
                "0 1 auto"
            ],
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading.H3, {
                    width: "100%",
                    textAlign: [
                        "center",
                        null,
                        "left"
                    ],
                    mb: 7,
                    children: "What’s your address?"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
                    flexDirection: "column",
                    width: "100%",
                    mb: 7,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
                            flexDirection: [
                                "column",
                                null,
                                "row"
                            ],
                            mb: 6,
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box_Box/* default */.Z, {
                                    flex: 2,
                                    mr: [
                                        null,
                                        null,
                                        4
                                    ],
                                    mb: [
                                        3,
                                        null,
                                        0
                                    ],
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.ZP, {
                                        analyticsName: "cosmos-manual-address-page-street",
                                        id: "street1",
                                        name: "street1",
                                        value: address.street1,
                                        onChange: function(_event, value) {
                                            return _this.handleOnChange("street1", value);
                                        },
                                        placeholder: "Street Address",
                                        "aria-label": "Street Address",
                                        type: "text",
                                        unboundedWidth: true
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box_Box/* default */.Z, {
                                    flex: 1,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.ZP, {
                                        analyticsName: "cosmos-manual-address-page-unit-number",
                                        id: "unit",
                                        name: "unit",
                                        value: address.unit,
                                        onChange: function(_event, value) {
                                            return _this.handleOnChange("unit", value);
                                        },
                                        placeholder: "Unit Number",
                                        "aria-label": "Unit Number",
                                        type: "text",
                                        unboundedWidth: true
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
                            flexDirection: [
                                "column",
                                null,
                                "row"
                            ],
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
                                    flexDirection: [
                                        "column",
                                        null,
                                        "row"
                                    ],
                                    flex: 2,
                                    mr: [
                                        null,
                                        null,
                                        4
                                    ],
                                    mb: [
                                        3,
                                        null,
                                        0
                                    ],
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box_Box/* default */.Z, {
                                            flex: 2,
                                            mr: [
                                                null,
                                                null,
                                                4
                                            ],
                                            mb: [
                                                3,
                                                null,
                                                0
                                            ],
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.ZP, {
                                                analyticsName: "cosmos-manual-address-page-city",
                                                id: "city",
                                                name: "city",
                                                value: address.city,
                                                onChange: function(_event, value) {
                                                    return _this.handleOnChange("city", value);
                                                },
                                                placeholder: "City",
                                                "aria-label": "City",
                                                type: "text",
                                                unboundedWidth: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box_Box/* default */.Z, {
                                            flex: 1,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.ZP, {
                                                analyticsName: "cosmos-manual-address-page-state",
                                                id: "state",
                                                name: "state",
                                                value: address.state,
                                                onChange: function(_event, value) {
                                                    return _this.handleOnChange("state", value);
                                                },
                                                placeholder: "State",
                                                "aria-label": "State",
                                                type: "text",
                                                unboundedWidth: true
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box_Box/* default */.Z, {
                                    flex: 1,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.ZP, {
                                        analyticsName: "cosmos-manual-address-page-postal-code",
                                        id: "postal_code",
                                        name: "postal_code",
                                        value: address.postal_code,
                                        onChange: function(_event, value) {
                                            return _this.handleOnChange("postal_code", value);
                                        },
                                        placeholder: "Postal Code",
                                        "aria-label": "Postal Code",
                                        type: "text",
                                        unboundedWidth: true
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
                    flexDirection: [
                        "column",
                        null,
                        "row"
                    ],
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.ZP, {
                            onClick: this.handleModifyAddress,
                            disabled: !address.street1 || !address.city || !address.state || !address.postal_code,
                            mr: [
                                null,
                                null,
                                4
                            ],
                            mb: [
                                3,
                                null,
                                0
                            ],
                            loading: this.state.loadingSubmit,
                            "aria-label": "Submit modified address",
                            analyticsName: "cosmos-manual-address-page-submit-modified-address",
                            children: "Continue"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.ZP, {
                            variant: "secondary",
                            onClick: this.handleCancel,
                            "aria-label": "Cancel address modification",
                            analyticsName: "cosmos-manual-address-page-cancel-address-modification",
                            children: "Cancel"
                        })
                    ]
                })
            ]
        });
    };
    return ManualAddressPage;
}(react.PureComponent);

;// CONCATENATED MODULE: ./src/components/mail/SuccessPage.tsx






var SuccessPage = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SuccessPage, _PureComponent);
    var _super = (0,_create_super/* default */.Z)(SuccessPage);
    function SuccessPage() {
        (0,_class_call_check/* default */.Z)(this, SuccessPage);
        return _super.apply(this, arguments);
    }
    var _proto = SuccessPage.prototype;
    _proto.render = function render() {
        var casaAddress = this.props.casaAddress;
        var unit = casaAddress && casaAddress.unitNumber && casaAddress.unitNumber ? casaAddress.unitType + " " + casaAddress.unitNumber : null;
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box_Box/* default */.Z, {
            maxWidth: "600px",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading.H3, {
                    width: "100%",
                    textAlign: [
                        "center",
                        null,
                        "left"
                    ],
                    mb: 7,
                    children: "You’ve successfully unsubscribed!"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text_Text/* default */.Z, {
                    textAlign: [
                        "center",
                        null,
                        "left"
                    ],
                    mb: 7,
                    children: [
                        "We’ve removed ",
                        casaAddress ? casaAddress.street : "your home",
                        unit && ", ".concat(unit),
                        " from our mailing list. You may receive one more piece of mail if it’s been processed before your unsubscribe which may arrive over the next 6-8 weeks."
                    ]
                })
            ]
        });
    };
    return SuccessPage;
}(react.PureComponent);

// EXTERNAL MODULE: ./node_modules/@opendoor/cinderblocks/es/growth/GoogleMapDisplay/index.mjs + 2 modules
var GoogleMapDisplay = __webpack_require__(32804);
;// CONCATENATED MODULE: ./src/components/mail/VerifyAddressPage.tsx







var VerifyAddressPage = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(VerifyAddressPage, _PureComponent);
    var _super = (0,_create_super/* default */.Z)(VerifyAddressPage);
    function VerifyAddressPage() {
        (0,_class_call_check/* default */.Z)(this, VerifyAddressPage);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            loadingUnsubscribe: false
        };
        _this.handleUnsubscribe = function() {
            _this.setState({
                loadingUnsubscribe: true
            });
            _this.props.unsubscribeAddress();
        };
        return _this;
    }
    var _proto = VerifyAddressPage.prototype;
    _proto.render = function render() {
        var _props = this.props, casaAddress = _props.casaAddress, googleMapsApiKey = _props.googleMapsApiKey, googleMapsOptions = _props.googleMapsOptions;
        var center = {
            lat: casaAddress.latitude,
            lng: casaAddress.longitude
        };
        var unit = casaAddress.unitType + " " + casaAddress.unitNumber;
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box_Box/* default */.Z, {
            flex: [
                "1 0 auto",
                null,
                "0 1 auto"
            ],
            minWidth: [
                "0px",
                null,
                "600px"
            ],
            textAlign: "center",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box_Box/* default */.Z, {
                    mb: 8,
                    width: "100%",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GoogleMapDisplay/* GoogleMapDisplay */.p, {
                        options: googleMapsOptions,
                        center: center,
                        googleMapsApiKey: googleMapsApiKey,
                        height: "300px"
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text_Text/* default */.Z, {
                    fontSize: "s3",
                    fontWeight: "semibold",
                    mb: 6,
                    lineHeight: "s3",
                    children: [
                        casaAddress.street,
                        unit && ", ".concat(unit),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                        casaAddress.city,
                        ", ",
                        casaAddress.state,
                        " ",
                        casaAddress.postalCode
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text_Text/* default */.Z, {
                    fontSize: "s1",
                    mb: 8,
                    children: "Is this the correct address?"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
                    flexDirection: [
                        "column",
                        null,
                        "row"
                    ],
                    width: "100%",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.ZP, {
                            mr: [
                                null,
                                null,
                                4
                            ],
                            mb: [
                                3,
                                null,
                                0
                            ],
                            onClick: this.handleUnsubscribe,
                            loading: this.state.loadingUnsubscribe,
                            "aria-label": "Confirm address is correct",
                            analyticsName: "cosmos-verify-address-page-confirm-correct-address",
                            children: "Yes, that’s right"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.ZP, {
                            variant: "secondary",
                            onClick: this.props.toManualAddressVerification,
                            "aria-label": "",
                            analyticsName: "cosmos-verify-address-page-fix-address",
                            children: "Add unit # or fix address"
                        })
                    ]
                })
            ]
        });
    };
    return VerifyAddressPage;
}(react.PureComponent);

;// CONCATENATED MODULE: ./src/components/mail/UnsubscribePage.tsx















var Sentry = observability_slim/* globalObservability.getSentryClient */.w.getSentryClient();
var UnsubscribePage = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(UnsubscribePage, _PureComponent);
    var _super = (0,_create_super/* default */.Z)(UnsubscribePage);
    function UnsubscribePage() {
        (0,_class_call_check/* default */.Z)(this, UnsubscribePage);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            casaAddress: null,
            pageType: "address-entry"
        };
        _this.submitAddress = function(address) {
            (0,api/* standardizeAddress */.ce)(address).then(function(response) {
                if (!response || !response.data || response.errors) {
                    _this.setState({
                        pageType: "manual"
                    });
                } else {
                    _this.setState({
                        casaAddress: _this.getCasaAddressData(response.data),
                        pageType: "verify"
                    });
                }
            });
        };
        _this.unsubscribeAddress = function(address) {
            if (address && address.addressUuid) {
                (0,components_api/* unsubscribeMailer */.Y)(address.addressUuid).then(function(response) {
                    if (!response || !response.data || response.errors) {
                        var ref;
                        _this.setState({
                            pageType: "error"
                        });
                        (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, "Unsubscribe mailer request failed", {
                            captureContext: {
                                extra: {
                                    error: response.message
                                }
                            }
                        });
                    } else {
                        _this.setState({
                            pageType: "success"
                        });
                    }
                });
            } else {
                _this.setState({
                    pageType: "error"
                });
            }
        };
        _this.cancelManualAddressVerification = function(hasAddressInput) {
            _this.setState({
                pageType: hasAddressInput ? "verify" : "address-entry"
            });
        };
        return _this;
    }
    var _proto = UnsubscribePage.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Flex/* default */.Z, {
            justifyContent: "center",
            my: 12,
            px: [
                7,
                10
            ],
            children: this.renderUnsubscribeSection()
        });
    };
    _proto.renderUnsubscribeSection = function renderUnsubscribeSection() {
        var _this = this;
        var _state = this.state, casaAddress = _state.casaAddress, pageType = _state.pageType;
        switch(pageType){
            case "error":
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ErrorPage, {
                    casaAddress: casaAddress
                });
            case "success":
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SuccessPage, {
                    casaAddress: casaAddress
                });
            case "manual":
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ManualAddressPage, {
                    addressInput: casaAddress && this.casaAddressToAddressInput(casaAddress),
                    cancelManualAddressVerification: this.cancelManualAddressVerification,
                    modifyAddress: this.submitAddress
                });
            case "verify":
                if (casaAddress) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerifyAddressPage, {
                        casaAddress: casaAddress,
                        googleMapsApiKey: globals/* GOOGLE_MAPS_API_KEY */.eu,
                        toManualAddressVerification: function() {
                            return _this.setState({
                                pageType: "manual"
                            });
                        },
                        unsubscribeAddress: function() {
                            return _this.unsubscribeAddress(casaAddress);
                        }
                    });
                }
                this.setState({
                    pageType: "error"
                });
                return;
            default:
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AddressEntryPage, {
                    onChooseManualEntry: function() {
                        return _this.setState({
                            pageType: "manual"
                        });
                    },
                    onSubmit: this.submitAddress
                });
        }
    };
    _proto.getCasaAddressData = function getCasaAddressData(data) {
        if (!data.casa || !data.casa.findByFields || !data.casa.findByFields.address) {
            return {};
        }
        var address = data.casa.findByFields.address;
        return {
            addressUuid: address.uuid,
            city: address.city,
            latitude: address.latitude,
            longitude: address.longitude,
            postalCode: address.postalCode,
            state: address.state,
            street: address.street,
            unitNumber: address.unitNumber,
            unitType: address.unitType
        };
    };
    _proto.casaAddressToAddressInput = function casaAddressToAddressInput(address) {
        return {
            city: address.city || "",
            postal_code: address.postalCode || "",
            state: address.state || "",
            street1: address.street || "",
            unit: address.unitNumber || ""
        };
    };
    return UnsubscribePage;
}(react.PureComponent);

// EXTERNAL MODULE: ./src/components/shared/Footer.tsx + 2 modules
var Footer = __webpack_require__(13390);
// EXTERNAL MODULE: ./src/components/shared/Layout.tsx + 1 modules
var Layout = __webpack_require__(69224);
;// CONCATENATED MODULE: ./src/pages/mail.tsx





var Mail = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Layout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UnsubscribePage, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var mail = (Mail);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9842,2767,5569,5662,7166,6937,4638,6930,1138,8058,8730,9774,2888,179], function() { return __webpack_exec__(95821); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);